import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-boys',
  templateUrl: './boys.component.html',
  styleUrls: ['./boys.component.css']
})
export class BoysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/boys/boys.component.ts